import React from 'react'

import './style.css'

export default function GiphyPreview({
  addGiphyToMessage,
  giphy
}) {
  const handleOnClick = () => addGiphyToMessage(giphy)

  const imgAlt = giphy?.title ?? 'Gif from Giphy'

  return (
    <li className="drift-widget-composer-giphy-list-item">
      <button
        aria-label={imgAlt}
        className='giphy-button'
        onClick={handleOnClick}
      >
        <img
          alt={imgAlt}
          aria-label={imgAlt}
          className="giphy-animated"
          src={giphy.images.preview_gif.url}
        />
        <img
          alt={imgAlt}
          aria-label={imgAlt}
          className="giphy-still"
          src={giphy.images.original_still.url}
        />
      </button>
    </li>
  )
}
